import { useWidgetContext } from '../Widget.hooks'
import { WidgetHeaderContentActions } from '../WidgetHeaderContentActions'
import { WidgetHeaderContentTitle } from '../WidgetHeaderContentTitle'

import * as styles from './WidgetHeaderContent.module.css'

function WidgetHeaderContent({
  Actions = WidgetHeaderContentActions,
  Title = WidgetHeaderContentTitle,
  actionsProps,
  className = styles.WidgetHeaderContent,
  title,
  titleProps,
}) {
  const { handleToggleExpanded } = useWidgetContext()

  return (
    <div className={className} onClick={handleToggleExpanded}>
      <Title {...titleProps} title={title} />

      {Actions ? <Actions {...actionsProps} /> : null}
    </div>
  )
}

export default WidgetHeaderContent
